export default __webpack_public_path__ + "static/media/empty.76a7f155.svg";